import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash-firecloud';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "./localisation.module";
export var LocaleLangs;
(function (LocaleLangs) {
    LocaleLangs["english"] = "en";
    LocaleLangs["swedish"] = "sv";
})(LocaleLangs || (LocaleLangs = {}));
var LocalisationService = /** @class */ (function () {
    function LocalisationService(translate) {
        this.translate = translate;
    }
    LocalisationService.prototype.start = function () {
        this.translate.addLangs([
            LocaleLangs.english,
            LocaleLangs.swedish
        ]);
        this.translate.setDefaultLang(LocaleLangs.english);
        var browserLang = this.translate.getBrowserLang();
        var chosenLang = _.includes(this.translate.getLangs(), browserLang) ? browserLang : LocaleLangs.english;
        this.translate.use(chosenLang);
    };
    LocalisationService.ngInjectableDef = i0.defineInjectable({ factory: function LocalisationService_Factory() { return new LocalisationService(i0.inject(i1.TranslateService)); }, token: LocalisationService, providedIn: i2.LocalisationModule });
    return LocalisationService;
}());
export { LocalisationService };
